import { render } from "./Form.vue?vue&type=template&id=90b1e74a&ts=true"
import script from "@/composables/pages/master-setting/route/FormComposable?vue&type=script&lang=ts"
export * from "@/composables/pages/master-setting/route/FormComposable?vue&type=script&lang=ts"

import "./Form.vue?vue&type=style&index=0&id=90b1e74a&lang=scss"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__